import React from "react";
import Fade from "react-reveal/Fade";

const Description = () => {
  return (
    <Fade>
      <div className="center_wrapper">
        <h2>Highlights</h2>
        <div className="highlight_description">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae
          voluptate at illum incidunt officia totam perspiciatis voluptates quod
          ullam ut?
        </div>
      </div>
    </Fade>
  );
};

export default Description;
